import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { FaqItem, FaqListResponse } from '../../application/types';

export async function fetchFaqList(): Promise<FaqItem[]> {
  const response = await createPublicClient().get<{ data: FaqListResponse }>(
    '/faq/list',
    { params: { page: 1, limit: 100, isActive: true } },
  );
  return response.data?.data?.list ?? [];
}
